module.exports = __webpack_public_path__ + "img/editProfile-upload.1c8d2d92.svg";